"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageTypeProp = exports.PAGE_TYPE_PROP = void 0;
const get_1 = __importDefault(require("lodash/get"));
exports.PAGE_TYPE_PROP = '_pt';
function getPageTypeProp(pageProps) {
    return (0, get_1.default)(pageProps, ['props', exports.PAGE_TYPE_PROP], (0, get_1.default)(pageProps, exports.PAGE_TYPE_PROP, null));
}
exports.getPageTypeProp = getPageTypeProp;
//# sourceMappingURL=PageType.prop.js.map